import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { Steps } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Step1 from "../../components/Estimate/Step1/Step1";
import Step2 from "../../components/Estimate/Step2/Step2";
import Step3 from "../../components/Estimate/Step3/Step3";
import { getForm, getSteps } from "../../store/policy";
import { User, Users, FileCheck, ChevronRight } from "lucide-react";
import logo from "../../utils/img/loginLogo.png";

const stepIcons = [
  <User size={18} />,
  <Users size={18} />,
  <FileCheck size={18} />,
];

const Index = ({ curr }) => {
  const dispatch = useDispatch();
  const [current, setCurrent] = useState(null);

  const { form, steps } = useSelector((state) => state.policySlice);

  useEffect(() => {
    if (sessionStorage.getItem("lastStep")) {
      setCurrent(parseInt(sessionStorage.getItem("lastStep")) && parseInt(sessionStorage.getItem("lastStep"))>3 ? 3 : parseInt(sessionStorage.getItem("lastStep")) );
    } else {
      setCurrent(1);
    }
    if (!form) {
      dispatch(getForm());
    }
  }, [dispatch, form]);

  useEffect(() => {
    const estimateForm = form?.find((f) => f?.sequence === 1);
    if (estimateForm?.id) {
      dispatch(getSteps(estimateForm.id));
    }
  }, [form, dispatch]);

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <div className={styles.topBarInner}>
          <div className={styles.brandMark}>
            <img src={logo} alt="Eden Care" className={styles.brandLogo} />
          </div>
          <div className={styles.topBarRight}>
            <span className={styles.topBarBadge}>Estimate</span>
          </div>
        </div>
      </div>

      <div className={styles.main}>
        <div className={styles.container}>
          {/* Header */}
          <div className={styles.header}>
            <h1 className={styles.headingMain}>
              {form?.find((f) => f?.sequence === 1)?.title}
            </h1>
            <p className={styles.subHeading}>
              Complete the steps below to get your personalized insurance quote
            </p>
          </div>

          {/* Custom Stepper */}
          <div className={styles.stepper}>
            {steps &&
              steps.length > 0 &&
              steps.map((_, i) => {
                const step = steps.find((s) => s?.step_number === i + 1);
                const isActive = current - 1 === i;
                const isCompleted = current - 1 > i;
                return (
                  <React.Fragment key={i}>
                    <div
                      className={`${styles.stepItem} ${
                        isActive ? styles.stepActive : ""
                      } ${isCompleted ? styles.stepCompleted : ""}`}
                    >
                      <div className={styles.stepCircle}>
                        {isCompleted ? (
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        ) : (
                          stepIcons[i] || <span>{i + 1}</span>
                        )}
                      </div>
                      <div className={styles.stepLabel}>
                        <span className={styles.stepNumber}>Step {i + 1}</span>
                        <span className={styles.stepTitle}>{step?.title}</span>
                      </div>
                    </div>
                    {i < steps.length - 1 && (
                      <div
                        className={`${styles.stepConnector} ${
                          isCompleted ? styles.stepConnectorDone : ""
                        }`}
                      />
                    )}
                  </React.Fragment>
                );
              })}
          </div>

          {/* Step Content */}
          <div className={styles.stepContainer}>
            {current === 1 ? (
              <Step1 setCurrent={setCurrent} current={current} />
            ) : current === 2 ? (
              <Step2 setCurrent={setCurrent} current={current} />
            ) : current === 3 ? (
              <Step3 setCurrent={setCurrent} current={current} />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
